import {
  Button,
  Col,
  Descriptions,
  Modal,
  Row,
  Space,
  message,
  Spin,
} from "antd";
import {
  AudioOutlined,
  VideoCameraOutlined,
  SoundFilled,
  CheckCircleOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";

import { useEffect, useRef, useState, memo } from "react";
import "./AppointmentJoinModal.scss";
import utils from "utils";
import { useHistory } from "react-router-dom";
import { AudioInputTest, testAudioInputDevice } from "@twilio/rtc-diagnostics";
import api from "utils/api";
import { CONSTANTS } from "utils/constant";

const Video = require("twilio-video");
const { runPreflight } = require("twilio-video");

let audioInputTest;
// let recordingURL = "";
const audioEl = new Audio();
let interval = null;

const AppointmentJoinModal = ({
  setShowJoinModal,
  apptDetail,
  role,
  redirectPath,
  doctor_last_name,
  patient_last_name,
  is_video_call = true
}) => {
  const history = useHistory();

  const [countdown, setCountdown] = useState(6);

  const [testCount, setTestCount] = useState(0);

  const localVideoTrackRef = useRef(null);

  const [listening, setListening] = useState(false);

  const [previewing, setPreviewing] = useState(false);

  const [playingAudio, setPlayingAudio] = useState(false);

  const [testResults, setTestResults] = useState([]);

  const [disableActions, setDisableActions] = useState(false);

  const [disableVideo, setDisableVideo] = useState(false);

  const [disableAudio, setDisableAudio] = useState(false);

  const handleAudio = () => {
    if (listening && audioInputTest) {
      audioInputTest.stop();
    } else {
      setDisableAudio(true);
      setTestResults((prevState) => ({
        ...prevState,
        audio: {
          status: "loading",
          label: "Recording Audio",
        },
      }));
      setCountdown(6);
      interval = setInterval(() => {
        setCountdown((prevCountdown) => prevCountdown - 1);
      }, 1000);
      setTestCount((prevTstCount) => prevTstCount + 1);
      audioInputTest = testAudioInputDevice({ enableRecording: true });
      audioInputTest.on(AudioInputTest.Events.Volume, (Volume) => {
        if (!listening) {
          setListening(true);
        }
      });

      audioInputTest.on(AudioInputTest.Events.Error, (error) => {
        setTestResults((prevState) => ({
          ...prevState,
          audio: {
            status: "error",
            label: "Audio Error",
          },
        }));
        audioInputTest.stop(true);
        setListening(false);
        setDisableAudio(false);
        setTestCount((prevCountdown) => prevCountdown - 1);
      });

      audioInputTest.on(AudioInputTest.Events.End, (report) => {
        if (report.errors.length == 0 && !audioEl.muted) {
          audioEl.src = report.recordingUrl;
          setPlayingAudio(true);
          setTestResults((prevState) => ({
            ...prevState,
            audio: {
              status: "loading",
              label: "Playing Audio",
            },
          }));
          audioEl.play();
          audioEl.addEventListener("ended", function () {
            setPlayingAudio(false);
            setTestResults((prevState) => ({
              ...prevState,
              audio: {
                status: "success",
                label: "Audio Tested",
              },
            }));
          });
          setListening(false);
          setDisableAudio(false);
        }

        // // Revoke the url if no longer needed
        // URL.revokeObjectURL(report.recordingUrl);
      });
    }
  };

  const playAudio = () => {
    setTestCount((prevTstCount) => prevTstCount - 1);
    audioEl.muted = false;
    audioInputTest.stop();
    setListening(false);
    setDisableAudio(false);
  };

  const handleVideo = () => {
    if (previewing && localVideoTrackRef.current) {
      localVideoTrackRef.current.stop();
      setPreviewing(!previewing);
    } else {
      setDisableVideo(true);
      setTestResults((prevState) => ({
        ...prevState,
        video: {
          status: "loading",
          label: "Checking Video",
        },
      }));
      if (!localVideoTrackRef.current) {
        // Video.createLocalVideoTrack({
        //   width: 548,
        //   height: 224,
        // })
        setTestCount((prevTstCount) => prevTstCount + 1);
        Video.createLocalVideoTrack()
          .then(function (videoTrack) {
            localVideoTrackRef.current = videoTrack;
            const container = document.getElementById("video-container");
            container.appendChild(videoTrack.attach());
            setPreviewing(!previewing);
            setTestResults((prevState) => ({
              ...prevState,
              video: {
                status: "success",
                label: "Video Tested",
              },
            }));
            setDisableVideo(false);
            setTestCount((prevTstCount) => prevTstCount - 1);
          })
          .catch((error) => {
            setTestResults((prevState) => ({
              ...prevState,
              video: {
                status: "error",
                label: "Video Error",
              },
            }));
            setDisableVideo(false);
            setTestCount((prevTstCount) => prevTstCount - 1);
          });
      } else {
        localVideoTrackRef.current.restart();
        setTestResults((prevState) => ({
          ...prevState,
          video: {
            status: "success",
            label: "Video Tested",
          },
        }));
        setPreviewing(!previewing);
        setDisableVideo(false);
      }
    }
  };

  const handleRedirection = (resp_app, token, patientOffSet) => {
    if (role == "doctor") {
      let path = `/doctor/video-consultation`;
      history.push({
        pathname: path,
        state: {
          identity: resp_app.appointment_doctor_user_id,
          rmt_prtcp_id: resp_app.appointment_patient_user_id,
          localUserName: resp_app.appointment_doctor,
          localUserLastName: resp_app.doctor_last_name,
          remoteUserName: resp_app.appointment_patient,
          remoteUserLastName: resp_app.appointment_patient_last_name,
          doc_api_id: resp_app.appointment_doctor_id,
          pat_identity: resp_app.appointment_patient_id,
          gender: resp_app?.appointment_patient_gender,
          user_type: resp_app?.appointment_patient_user_type,
          is_doctor: true,
          token: token,
          roomName: resp_app.appointment_id,
          type: role,
          age: resp_app?.age,
          localusr: resp_app.salutation + ". " + resp_app.appointment_doctor,
          remoteusr: resp_app.appointment_patient,
          appointment_date: resp_app.appointment_date,
          appointment_utc_date_time: resp_app.appointment_utc_date_time,
          appointment_patient_is_evaluated:
            resp_app.appointment_patient_is_evaluated,
          is_multiple_session: resp_app.is_multiple_session,
          patient_off_set: patientOffSet,
          is_video_call:resp_app.is_video_call
        },
      });
    } else if (role == "patient") {
      let path = `/logged-in-user/video-consultation`;
      history.push({
        pathname: path,
        state: {
          identity: resp_app.appointment_patient_user_id,
          rmt_prtcp_id: resp_app.appointment_doctor_user_id,
          localUserName: resp_app.appointment_patient,
          localUserLastName: resp_app.patient_last_name,
          remoteUserName: resp_app.appointment_doctor,
          remoteUserLastName: resp_app.doctor_last_name,
          is_doctor: false,
          token: token,
          roomName: resp_app.appointment_id,
          type: role,
          localusr: resp_app.appointment_patient,
          remoteusr:
            resp_app.doctor_salutation + ". " + resp_app.appointment_doctor,
          appointment_date: resp_app.appointment_date,
          appointment_utc_date_time: resp_app.appointment_utc_date_time,
          is_video_call:resp_app.is_video_call
        },
      });
    }
  };

  const handleTestConnection = (testConn) => {
    let data = {
      app_id:
        role == "doctor"
          ? apptDetail?.appointment_id
          : apptDetail?.app_id || apptDetail?.appointment_id,
      type: role,
    };
    setDisableActions(true);
    api
      .get_joinNow_appointment_details(data)
      .then((response) => {
      if(response?.data?.status == 200){
        let resp_twilio = response?.data?.data?.twilio;
        let resp_app = response?.data?.data?.appointment;
        let patientOffSet =
          response?.data?.data.appointment.patient_timezone_offset_in_min;
        if (
          ((resp_twilio.doctor_token == null ||
            resp_twilio.doctor_token == "undefined" ||
            resp_twilio.doctor_token == "") &&
            role == "doctor") ||
          ((resp_twilio.patient_token == null ||
            resp_twilio.patient_token == "undefined" ||
            resp_twilio.patient_token == "") &&
            role == "patient")
        ) {
          let msg =
            "Video Consultation can be joined only 5 minute before schedule and Time Remaining is " +
            resp_app.appointment_time_difference;
          message.warning(msg, ErrorDuration);
          setDisableActions(false);
        } else {
          let token =
            role == "doctor"
              ? response?.data?.data?.twilio?.doctor_token
              : response?.data?.data?.twilio?.patient_token;

          if (testConn) {
            setTestResults((prevState) => ({
              ...prevState,
              connection: {
                status: "loading",
                label: "Checking Connectivity",
              },
            }));

            const preflightTest = runPreflight(token);
            // preflightTest.on("progress", (progress) => {
            //   console.log("Test inprogress", progress);
            // });
            preflightTest.on("failed", (error, report) => {
              let data = {
                app_id:
                  role == "doctor"
                    ? apptDetail?.appointment_id
                    : apptDetail?.app_id || apptDetail?.appointment_id,
                type: role,
                status: "Failure",
              };
              setTestResults((prevState) => ({
                ...prevState,
                connection: {
                  status: "error",
                  label: "Connection Error",
                },
              }));
              setDisableActions(false);
              api
                .submit_preflight_error(data)
                .then((res) => {})
                .catch((err) => {});
            });

            preflightTest.on("completed", (report) => {
              setDisableActions(false);
              setTestResults((prevState) => ({
                ...prevState,
                connection: {
                  status: "success",
                  label: "Connection Successful",
                },
              }));
              handleRedirection(resp_app, token, patientOffSet);
            });
          } else {
            setTestResults((prevState) => ({
              ...prevState,
              connection: {
                status: "loading",
                label: "Connecting...",
              },
            }));
            handleRedirection(resp_app, token, patientOffSet);
          }
        }
      }else{
        message.error(response?.data?.message, ErrorDuration);
        setDisableActions(false);
      }
      })
      .catch((err) => {
        setTestResults((prevState) => ({
          ...prevState,
          connection: {
            status: "error",
            label: "Error Occured",
          },
        }));
        setDisableActions(false);
      });
  };

  const handleCancel = () => {
    if (redirectPath) {
      history.replace({
        pathname: redirectPath,
        state: { loadDashboard: true },
      });
    } else {
      setShowJoinModal(false);
    }
  };

  useEffect(() => {
    if (countdown == 0) {
      clearInterval(interval);
      playAudio();
    }
  }, [countdown]);

  useEffect(() => {
    if(!is_video_call)
      handleTestConnection(false)
    return () => {
      clearInterval(interval);
      if (localVideoTrackRef.current) {
        localVideoTrackRef.current.stop();
      }
      // Revoke the recorded audio url
      audioEl.pause();
      URL.revokeObjectURL(audioEl.src);
      if (audioInputTest) {
        audioEl.muted = true;
        audioInputTest.stop();
      }
    };
  }, []);

  return (
    <>
      <Modal open={is_video_call} centered closable={false} footer={null} width={600}>
        <div className="appointment-join-modal-container">
          <Row justify="start">
            <Col span={24}>
              <h3>{CONSTANTS.APPOINTMENT_DETAILS}</h3>
            </Col>
          </Row>
          <Space direction="vertical" size="large">
            <Row gutter={8} justify="start">
              <Col span={24}>
                {(apptDetail?.doctor_name ||
                  apptDetail?.patient_name ||
                  apptDetail?.appointment_patient) && (
                  <Descriptions size="small" layout="horizontal">
                    {role == "doctor" ? (
                      <Descriptions.Item label="">
                        <span style={{ fontSize: 16, display: "flex" }}>
                          {utils.FirstNameLastName(utils.FormatName(utils.getDisplayName(
                            apptDetail?.patient_name ||
                              apptDetail?.appointment_patient, patient_last_name
                          )), "250px")} | {apptDetail?.age} years | {utils.Capitalize(
                            apptDetail?.gender ||
                              apptDetail?.appointment_patient_gender ||
                              "Male"
                          )}
                        </span>
                      </Descriptions.Item>
                    ) : (
                      <Descriptions.Item label="">
                        <span style={{ fontSize: 16 }}>
                          {utils.FirstNameLastName(utils.salutationPrefixName((apptDetail?.salutation || apptDetail?.doctor_salutation), utils.getDisplayName(apptDetail?.doctor_name ||apptDetail?.appointment_doctor, doctor_last_name)), "500px")}
                        </span>
                      </Descriptions.Item>
                    )}
                  </Descriptions>
                )}

                <Descriptions
                  size="small"
                  bordered
                  column={1}
                  layout="horizontal"
                >
                  <Descriptions.Item label={CONSTANTS.TIME}>
                    {utils.FormatDate(
                      apptDetail?.appointment_date_time ||
                        apptDetail?.appointment_date,
                      "DATE_TIME_3"
                    )}
                  </Descriptions.Item>
                  {apptDetail?.subscription_plan && (
                    <Descriptions.Item label={CONSTANTS.SUBSCRIPTION_PLAN}>
                      {utils.Capitalize(apptDetail?.subscription_plan)}
                    </Descriptions.Item>
                  )}
                </Descriptions>
              </Col>
            </Row>
            <Row gutter={[0, 10]}>
              <Col span={24}>
                <Space size="small" direction="horizontal" align="center">
                  <Button
                    className="audio-check-btn"
                    icon={<VideoCameraOutlined />}
                    disabled={disableVideo}
                    onClick={handleVideo}
                  >
                    {previewing
                      ? `${CONSTANTS.PREVIEWING}`
                      : `${CONSTANTS.PREVIEW_VIDEO}`}
                  </Button>
                  <Button
                    className="audio-check-btn"
                    icon={<AudioOutlined />}
                    onClick={handleAudio}
                    disabled={playingAudio || disableAudio}
                  >
                    {listening && !playingAudio
                      ? `${CONSTANTS.SAY_SOMETHING}`
                      : `${CONSTANTS.CHECK_AUDIO}`}
                  </Button>
                  {playingAudio && <SoundFilled className="play-icon" />}
                  {listening && (
                    <div className="timer-container">
                      <div className="timer">
                        <span>{countdown}</span>
                      </div>
                    </div>
                  )}
                </Space>
              </Col>
              <Col span={24}>
                <div id="video-container"></div>
              </Col>
            </Row>

            <Row
              gutter={8}
              justify="start"
              align="middle"
              className="audio-checking-space"
            >
              {Object.entries(testResults).map(([name, obj], index) => (
                <Col span={8} key={index}>
                  <Space size="small">
                    <span>{obj.label}</span>
                    {obj.status == "success" ? (
                      <CheckCircleOutlined className="success-icon" />
                    ) : obj.status == "error" ? (
                      <CloseCircleOutlined className="error-icon" />
                    ) : (
                      <Spin size="small" />
                    )}
                  </Space>
                </Col>
              ))}
            </Row>
            <Row justify="end">
              <Col span={18}>
                <Space size="middle">
                  <Button
                    className="cancelnow-btn"
                    onClick={handleCancel}
                    disabled={disableActions || testCount > 0}
                  >
                    {CONSTANTS.CANCEL}
                  </Button>
                  <Button
                    className="joinnow-btn"
                    onClick={() => handleTestConnection(true)}
                    disabled={disableActions}
                  >
                    {CONSTANTS.TEST_CONNECTION_JOIN}
                  </Button>
                  <Button
                    className="joinnow-btn"
                    onClick={() => handleTestConnection(false)}
                    disabled={disableActions}
                  >
                    {CONSTANTS.JOIN_NOW}
                  </Button>
                </Space>
              </Col>
            </Row>
          </Space>
        </div>
      </Modal>
    </>
  );
};
export default memo(AppointmentJoinModal);
